





























import Vue from 'vue';

import {Component, Prop} from 'vue-property-decorator';
import FormNavigationButton from '@/Components/FormNavigation/FormNavigationButton.vue'
import Section from '@/Types/Section';
import Page from '@/Types/Page';

@Component({
    components: {
        FormNavigationButton,
    },
})
export default class FormNavigation extends Vue {
    @Prop({type: Array, required: true}) sections!: Section[]
    @Prop({type: Object, required: true}) activeSection!: Section
    @Prop({type: Object, required: true}) activePage!: Page

    isActiveSection(sectionName: string): boolean {
        return this.activeSection.name === sectionName;
    }

    isActivePage(pageNum: number): boolean {
        return this.activePage.number === pageNum;
    }

    isDonePage(page: Page): boolean {
        return page.progress === 100;
    }

    isEnabledPage(page: Page): boolean {
        if (this.isDonePage(page)) {
            return true;
        }

        return this.isNextPage(page) && this.isDonePage(this.activePage);
    }

    isNextPage(page: Page): boolean {
        return this.activePage.number === page.number - 1;
    }

    pageLiClass(page: Page): string {
        const base: string[] = [];

        if (this.isActivePage(page.number)) {
            return [...base, 'formNavigation__page--active'].join(' ');
        }

        if (this.isEnabledPage(page)) {
            return [...base, 'formNavigation__page--enabled'].join(' ');
        }

        return base.join(' ');
    }

    sectionLiClass(): string {
        return '';
    }

    sectionInputClass(sectionName: string): string {
        const base: string[] = [];

        if (this.isActiveSection(sectionName)) {
            return [
                ...base,
                'font-bold',
                'hover:font-semibold',
            ].join(' ');
        }

        return base.join(' ');
    }

    pageButtonClass(page: Page): string {
        const base: string[] = [];

        if (this.isActivePage(page.number)) {
            return [...base, ...[
                'btn-circle-primary',
                'cursor-default',
            ]].join(' ');
        }

        return [...base, ...[
            'btn-circle-outlined-primary',
        ]].join(' ');
    }
}
